import React from 'react'
import { useInventoryBySerialNumberListContext } from './Context'
import { InventoryBySerialNumberListToolbox } from './InventoryBySerialNumberListToolbox'
import { Stack } from 'react-bootstrap'
import { NotRequiredSerialNumberMessage } from './NotRequiredSerialNumberMessage'
import { InventoryBySerialNumberListDataTable } from './InventoryBySerialNumberListDataTable'

export const Layout = () => {
  const { requiredSerialNumber } = useInventoryBySerialNumberListContext()

  if (!requiredSerialNumber) return <NotRequiredSerialNumberMessage />

  return (
    <Stack gap={2}>
      <InventoryBySerialNumberListToolbox />

      <InventoryBySerialNumberListDataTable />
    </Stack>
  )
}
